import React from "react";
import { Card } from "Components";
import { DateRange } from "./DateRange";
import { EntriesChart } from "./EntriesChart";
import styled from "styled-components";
import { MetricCard } from "./MetricCard";
import { useMultiDayEventContext } from "contexts/MultiDayEventContext";
import { AdvancedSettings } from "./AdvancedSettings";
import { Button } from "melodies-source/Button";
import { ReactComponent as SvgRefresh } from "assets/svg/refresh.svg";
export const MultiDay: React.FC = () => {
  const {
    utm,
    multiDayReportLoading,
    multiDayReportRefetching,
    refetchMultiDayReport,
  } = useMultiDayEventContext();

  return (
    <Card isElevated>
      <Controls>
        <DateRange />
        <Group>
          {!multiDayReportLoading && (
            <Button
              text
              onClick={refetchMultiDayReport}
              loading={multiDayReportRefetching}
              leftIcon={<SvgRefresh />}
            >
              Reload Report
            </Button>
          )}
          <AdvancedSettings />
        </Group>
      </Controls>
      <Grid>
        <EntriesChart />
        {utm?.enabled && (
          <>
            <MetricCard dataKey="entriesBySource" title="Entries By Source" />
            <MetricCard
              dataKey="conversionBySource"
              title="Conversion Rate By Source"
              infoBarsProps={{
                format: (count) => `${Math.round(count * 100)}%`,
              }}
            />
          </>
        )}
      </Grid>
    </Card>
  );
};

const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  position: relative;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
  }
`;

const Group = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  ${({ theme }) => theme.media.mobile} {
    display: flex;
    flex-direction: column;
  }
`;
